import apiBase from './apiBase';

class ZonesApi {
  static ImportZonesFromOtherTenant(data) {
    return apiBase.create().post('/zones/importFromOtherTenant', data);
  }
}

export default ZonesApi;
